const ClientPortfolio = {
  namespaced: true,
  state: {
    client_portfolios: [],
    selected_portfolio: null,
  },
  mutations: {
    setClientPortfolios(state, data){
      state.selected_portfolio = null
      state.client_portfolios = [...data]
    },
    setSelectedPortfolio(state, data){
      state.selected_portfolio = data
    },
  },
  actions: {
    setClientPortfolios(context, client_portfolios){
      context.commit('setClientPortfolios', client_portfolios)
    },
    setSelectedPortfolio(context, selected_portfolio){
      context.commit('setSelectedPortfolio', selected_portfolio)
    },
  }

};

export default ClientPortfolio;
